import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy, ChangeDetectorRef,
  Compiler, Component, ComponentFactory, ComponentRef, ModuleWithComponentFactories, NgModule, OnInit, ViewChild, ViewContainerRef
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import * as esri from 'esri-leaflet';
import * as L from 'leaflet';
import 'leaflet-easybutton';
import { GestureHandling } from "leaflet-gesture-handling";
import "leaflet-gesture-handling/dist/leaflet-gesture-handling.css";
import "leaflet.markercluster";
// import "leaflet/dist/images/marker-shadow.png";
import "leaflet/dist/leaflet.css";
import * as moment from 'moment';
//const moment = require("momentPack");
import { ModalDirective } from 'ngx-bootstrap/modal';
import { CarouselModule, OwlOptions } from 'ngx-owl-carousel-o';
import { LazyLoadScriptService } from '../../lazy_load_script_service';
import { PageService, SalaryscaleService } from '../../services';
import { Meta, Title } from '@angular/platform-browser';

declare function OneHr();
@Component({
  selector: 'app-salary-scale',
  templateUrl: './salaryScale.component.html',
  styleUrls: ['./salaryScale.component.scss']
})
export class salaryScaleComponent implements OnInit {

  @ViewChild('container', { static: true, read: ViewContainerRef }) container: ViewContainerRef;
  @ViewChild('myModal') public myModal: ModalDirective;

  private map;
  pageVars: any = {
    filters: { ds: { values: null, selected: 'all' }, aoe: { values: null, selected: 'all' }, aoi: { values: null, selected: 'all' }, ct: { values: null, selected: 'all' } },
    filtersSelected: {},
    urlObj: <any>{},
    countries: [],
    language: 'EN',
    locationSelected: null
  };

  private componentRef: ComponentRef<{}>;
  constructor(private service: PageService,
    public sanitizer: DomSanitizer,
    private compiler: Compiler,
    public cdRef: ChangeDetectorRef,
    private meta: Meta,
    private title: Title,
    private lazyLoadService: LazyLoadScriptService,
    public scale_service: SalaryscaleService, private router: Router) {
    this.meta.addTags([
      { name: 'description', content: 'Salary Scale page of UN - One HR - Salary Survey' },
      { name: 'author', content: 'One HR, Salary Survey' },
      { name: 'keyword', content: 'One HR, Salary Survey, Salary Scale' }
    ]);
    this.setTitle('UN - Salary Scale');
  }
  public setTitle(newTitle: string) {
    this.title.setTitle(newTitle);
  }
  slug = 'salary_scale';
  dutyStations: any = [];
  salaryScales: [];
  viewDutyStationURL;
  popupContent;
  popupContentHeader;
  template: string;
  statictemplate: string;

  public ngOnInit() {
    this.service.get(this.slug).subscribe((response: any) => {
      var str = response.data.html?.map(ele => ele.html).join("");
      this.statictemplate = `
      <div class="col-md-6">
      <div *ngIf="uniqueArray?.length">
        <h4 class="h4_scaleUpdte"> Latest Updates </h4>
        <div class="scale_scroll">
          <div class="wd-col w-col-4 w-col-small-small-stack" *ngFor="let i of uniqueArray">
            <div class="service-wrappers faq" (click)="viewScale(i.dutystation_info._id)">
              <div class="service-contents">
                <div class="container-2s w-containers">
                  <h5 class="heading-42 service">
                      {{i.country.name}} ({{i.dutystation_info.name}}) 
                  </h5>
                  <p>
                  <span>{{i.promulgated | date:"dd MMMM yyyy"}}</span>
                  <span *ngIf="i?.increaseSplMeasure?.length > 0"> ({{i.increaseSplMeasure}}) </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
      `;

      // <span *ngIf="i.lastInterimAdjustmentNA == false">
      //   Interim Adjustment - {{i.lastInterimAdjustment | date:"dd MMMM yyyy"}}
      // </span>

      // <span
      //   *ngIf="i.lastInterimAdjustmentNA == true && i.lastComprehensiveSalarySurveyorReferenceCheckDate != ''">
      //   Comprehensive Survey -
      //   {{i.lastComprehensiveSalarySurveyorReferenceCheckDate | date:"dd MMMM yyyy"}}
      // </span>
      str = str.replace('<div class="col-md-6">&#10;&#10;&#10;      </div>', `${this.statictemplate}`)
      this.template = str;
      this.compileTemplate();
    });
    this.fetchdutyStations();
    // this.initMap();
  }

  setsalaryScaleId(id) {
    //this.deleteItem = id;
  }

  openModel(popupData) {
    var customPopupHeader;
    var customPopup;
    this.viewDutyStationURL = "#/viewdutystation/" + popupData.dutyStationId._id;
    customPopupHeader = "<h3 class=\"\"><b>" + popupData.dutyStationId.name + " - " + popupData.dutyStationId.countryId.name + "</b>"
    customPopup = "</h3><div class=\"ssPopup_Content\"><b>ICSC Category: " + popupData.categoryId.name + "<br/>Last Completed Survey: ";

    if (popupData.lastComprehensiveSalarySurveyorReferenceCheck == 'date') {
      customPopup = customPopup + moment(popupData.lastComprehensiveSalarySurveyorReferenceCheckDate).format('MMMM YYYY');
    } else {
      customPopup = customPopup + "<a href=" + popupData.lastComprehensiveSalarySurveyorReferenceCheckLink + ">" + popupData.lastComprehensiveSalarySurveyorReferenceCheckDisplayText + "</a>";
    }

    if (popupData.nextComprehensiveSalarySurveyorReferenceCheck == 'date') {
      customPopup = customPopup + "<br/>Next Survey: " + moment(popupData.nextComprehensiveSalarySurveyorReferenceCheckDate).format('MMMM YYYY');
    } else {
      customPopup = customPopup + "<br/>Next Survey: <a href=" + popupData.nextComprehensiveSalarySurveyorReferenceCheckLink + ">" + popupData.nextComprehensiveSalarySurveyorReferenceCheckDisplayText + "</a>";
    }

    if (popupData.lastInterimAdjustmentNA === false) {
      customPopup = customPopup + "<br/>Last Interim Adjustment: " + moment(popupData.lastInterimAdjustment).format('MMMM YYYY');
    } else {
      customPopup = customPopup + "<br/>Last Interim Adjustment: N/A";
    }

    customPopup = customPopup + "<br/>Currency of Scale: " + popupData.currencyofScale + "<br/>Currency of Disbursement: " + popupData.currencyofDisbursement + "<br/>Special Measure: " + popupData.specialMeasures + "<br/><a href=" + this.viewDutyStationURL + ">Salary Scales</a></b></div>";
    this.popupContent = customPopup;
    this.popupContentHeader = customPopupHeader;

    this.myModal.show();
  }

  fetchdutyStations() {


    // var container = L.DomUtil.get('map');
    // if (container != null) {
    //     container._leaflet_id = null;
    // }
    // var southWest = L.latLng(40.712, -74.227),
    // northEast = L.latLng(40.774, -74.125),
    // bounds = L.latLngBounds(southWest, northEast);

    /* setTimeout((e)=>{

      console.log("Printing Duty Stations: ", this.dutyStations);
    

      
    },1000); */

    /* L.Map.addInitHook("addHandler", "gestureHandling", GestureHandling);
    this.map = L.map('map', {
      center: [28.0 ,0.0],
      dragging: !L.Browser.mobile,
      tap: !L.Browser.mobile,
      renderer: L.svg(),
      //maxBounds: bounds,
      minZoom: 1,
      maxZoom: 6,
      zoomSnap: 1.3,
      zoom: 1,
      zoomControl: true,
    }).fitWorld();

    if (L.Browser.mobile) {
      this.map.gestureHandling.enable();
      //map.dragging.enable(); 
      //console.log('mobileview')
      this.map.setMaxBounds(this.map.getBounds());
    }
    else{    
      this.map.dragging.disable();
      this.map.setMaxBounds(this.map.getBounds());
    } */

    // L.easyButton('<i class="fa fa-home" aria-hidden="true"></i>', function (btn, map) {
    //   map.setView([38.0, 0.0]);
    //   map.setZoom(1);
    // }).addTo(this.map);


    /* var tileLayer = esri.tiledMapLayer({
        url: "https://geoservices.un.org/arcgis/rest/services/ClearMap_WebGray/MapServer"
    });

    tileLayer.addTo(this.map);

    tileLayer.on("tileload", function (tileEvent) {
        tileEvent.tile.setAttribute('alt', 'Map tile image');
    }); */


    // L.marker.addMarkers(
    //   lng = -118.456554, lat = 34.085,
    //   label = "label w/ textsize 15px",
    //   labelOptions = labelOptions(noHide = T, textsize = "15px"));
    //var map = L.map('map').setView([51.505, -0.09], 13);
    // esri.tiledMapLayer({
    //   url: "https://geoservices.un.org/arcgis/rest/services/ClearMap_WebGray/MapServer"
    // }).addTo(this.map);

    //var marker = L.marker([51.5, -0.09]).addTo(map);
    //var marker = L.marker([33.0827, 50.2707], {icon: primaryIcon}).addTo(map).bindPopup('<b>Hello world!sdfsdfs</b><br />I am a popup.');
    // var title = new L.Control({ position: 'topright' });
    // title.onAdd = (map) => {
    //   var div = L.DomUtil.create('div', 'title');
    //   div.innerHTML += this.getMapTitle();
    //   return div;
    // };

    // title.addTo(map);

    //  this.map.touchZoom.disable();
    //  this.map.doubleClickZoom.disable();
    //  this.map.scrollWheelZoom.disable();
    //  this.map.boxZoom.disable();
    //  this.map.keyboard.disable();

    var primaryIcon = L.icon({
      iconUrl: 'assets/images/marker-icon.png',
      shadowUrl: 'assets/images/marker-shadow.png',
      iconSize: [28, 45], // size of the icon
      shadowSize: [50, 64], // size of the shadow
      iconAnchor: [22, 44], // point of the icon which wil correspond to marker's location
      shadowAnchor: [24, 62],  // the same for the shadow
      popupAnchor: [140, 80] // point from which the popup should open relative to the iconAnchor
    });
    // specify popup options 
    var customOptions = {
      'maxWidth': '600',
      'width': '600',
      'className': 'popupCustom'
    }

    var dutyStationList;
    var salaryScaleList;

    this.service.getDutyStation(this.slug).subscribe((response: any) => {
      //console.log('Duty Station response.data',response.data);
      if (response.data) {
        this.dutyStations = response.data.sort((a, b) => a.code > b.code ? 1 : -1);
      }
      this.dutyStations.unshift({ name: 'All', value: 'all', code: 'all' });
      this.service.getSalaryScale(this.slug).subscribe((response: any) => {
        // console.log('response.data',response.data);
        if (response.data) {
          this.salaryScales = response.data;

          //console.log('--->salaryScales',this.salaryScales);
          //this.length = response.data.total;
          dutyStationList = this.dutyStations;
          salaryScaleList = this.salaryScales;
          for (let x in salaryScaleList) {
            // if(dutyStationList[x].latitude && dutyStationList[x].longitude){
            var latitude = salaryScaleList[x].dutyStationId.latitude;
            var longitude = salaryScaleList[x].dutyStationId.longitude;
            var ds = [salaryScaleList[x].dutyStationId];
            this.viewDutyStationURL = "#/viewdutystation/" + salaryScaleList[x].dutyStationId._id;
            let result = salaryScaleList.filter(o1 => ds.some(o2 => o1.dutyStationId._id === o2._id));
            if (result.length > 0) {
              var customPopup;
              var r = result[0];
              // create popup contents r.lastComprehensiveSalarySurvey 
              customPopup = "<h3 class=\"ssPopup_Header\"><b>" + salaryScaleList[x].dutyStationId.name + " - " + salaryScaleList[x].dutyStationId.countryId.name + "</b></h3><div class=\"ssPopup_Content\"><b>ICSC Category: " + r.categoryId.name + "<br/>Last Completed Survey: ";
              //+moment(r.lastComprehensiveSalarySurvey).format('L')+"<br/>Next Comprehensive Salary Survey or Reference Check: "+moment(r.nextComprehensiveSalarySurvey).format('L')+"<br/>Last Interim Adjustment: "+moment(r.lastInterimSalarySurvey).format('L')+"<br/>Currency of Scale: "+moment(r.lastInterimSalarySurvey).format('L')+"<br/>Currency of Disbursement: "+moment(r.lastInterimSalarySurvey).format('L')+"<br/>Special Measures: "+r.specialMeasures+"<br/><a data-toggle=\"modal\" href=\"#myModal\">Salary Scales</a></b></div>";

              if (r.lastComprehensiveSalarySurveyorReferenceCheck == 'date') {
                customPopup = customPopup + moment(r.lastComprehensiveSalarySurveyorReferenceCheckDate).format('MMMM YYYY');
              } else {
                customPopup = customPopup + "<a href=" + r.lastComprehensiveSalarySurveyorReferenceCheckLink + ">" + r.lastComprehensiveSalarySurveyorReferenceCheckDisplayText + "</a>";
              }

              if (r.nextComprehensiveSalarySurveyorReferenceCheck == 'date') {
                customPopup = customPopup + "<br/>Next Survey: " + moment(r.nextComprehensiveSalarySurveyorReferenceCheckDate).format('MMMM YYYY');
              } else {
                customPopup = customPopup + "<br/>Next Survey: <a href=" + r.nextComprehensiveSalarySurveyorReferenceCheckLink + ">" + r.nextComprehensiveSalarySurveyorReferenceCheckDisplayText + "</a>";
              }

              if (r.lastInterimAdjustmentNA === false) {
                customPopup = customPopup + "<br/>Last Interim Adjustment: " + moment(r.lastInterimAdjustment).format('MMMM YYYY');
              } else {
                customPopup = customPopup + "<br/>Last Interim Adjustment: N/A";
              }
              customPopup = customPopup + "<br/>Currency of Scale: " + r.currencyofScale + "<br/>Currency of Disbursement: " + r.currencyofDisbursement + "<br/>Special Measure: " + r.specialMeasures + "<br/><a href=" + this.viewDutyStationURL + ">Salary Scales</a></b></div>";
              //console.log('before load '+dutyStationList[x].name+'=='+r);
              // L.marker([latitude, longitude], {icon: primaryIcon}).addTo(map).bindPopup(customPopup,customOptions).on('mouseover', function (e) {
              //        this.openPopup();
              // });
              this.popupContent = customPopup;
              // var marker = L.marker([latitude, longitude], { icon: primaryIcon }).addTo(this.map).on('click', this.openModel.bind(this,customPopup));

              // L.marker([48.850258, 2.351074], { icon: primaryIcon }).addTo(map).bindPopup(popup);


            }
            else {
              //L.marker([latitude, longitude], {icon: primaryIcon}).addTo(map);
            }
            //var marker = L.marker([13.0827, 80.2707], {icon: primaryIcon}).addTo(map).bindPopup('<b>Hello world!</b><br />I am a popup.');
          }
          setTimeout(() => {
            this.markLocation(this.salaryScales);
          }, 1000);
        }
      });
    });

  }

  markLocation(location) {
    this.initMap();
    var markers = L.markerClusterGroup();//{maxClusterRadius : 40}
    var markerList = [];
    var greenIcon = L.icon({
      iconUrl: 'assets/images/marker-icon.png',
      shadowUrl: 'assets/images/marker-shadow.png',
      iconAnchor: [13, 38], // point of the icon which will correspond to marker's location
      popupAnchor: [0, -45] // point from which the popup should open relative to the iconAnchor      
    });
    location
      .filter((e: any) => e.dutyStationId.longitude ? true : false)
      .forEach((e: any) => {
        if (e.dutyStationId.latitude && e.dutyStationId.longitude && e.dutyStationId.name) {
          try {
            // this.map.flyTo([e.dutyStationId.latitude, e.dutyStationId.longitude],2.10);
            var marker = L.marker([e.dutyStationId.latitude, e.dutyStationId.longitude], { icon: greenIcon }).on('click', this.openModel.bind(this, e)).bindTooltip(e.dutyStationId.name);
            markerList.push(marker);
          } catch (err) {
            console.log('err', err)
          }

        }
      });
    markers.addLayers(markerList);
    markers.on('clusterclick', e => e.layer.zoomToBounds());
    this.map.addLayer(markers);
  }

  private initMap() {
    if (this.map) {
      this.map.remove();
    }
    L.Map.addInitHook("addHandler", "gestureHandling", GestureHandling);

    // this.map = L.map('map', {
    //   center: [40.7225, 0.0],
    //   dragging: !L.Browser.mobile,
    //   tap: !L.Browser.mobile,
    //   renderer: L.svg(),
    //   minZoom: 2.00,
    //   maxZoom: 6,
    //   zoomSnap: 1.3,
    //   zoom: 1,
    //   zoomDelta: 2.0,
    //   zoomControl: true,
    // }).setView([40.7225, 0.0]);



    this.map = L.map('map', {
      // center: [38.0, 0.0],
      dragging: !L.Browser.mobile,
      tap: !L.Browser.mobile,
      renderer: L.svg(),
      minZoom: 1,
      maxZoom: 6,
      // zoomSnap: 1.3,
      zoom: 1,
      zoomControl: true,
    }).setView([38.0, 0.0], 2);

    if (L.Browser.mobile) {
      this.map.gestureHandling.enable();
      // this.map.setMaxBounds(this.map.getBounds());
    }

    L.easyButton('<i class="fa fa-home custom-space-2" aria-hidden="true"></i>', function (btn, map) {
      map.setView([38.0, 0.0], 2);
      // map.setZoom(1);
      // map.setZoomSnap(1.3);
    }).addTo(this.map);

    var tileLayer = esri.tiledMapLayer({
      url: "https://geoservices.un.org/arcgis/rest/services/ClearMap_WebGray/MapServer",
      // continuousWorld: false,
      // noWrap: true
    });

    tileLayer.addTo(this.map);

    tileLayer.on("tileload", function (tileEvent) {
      tileEvent.tile.setAttribute('alt', 'Map tile image');
    });
  }

  searchOpenings() {
    // let loc = 'SL/CLM/01_C01';
    let loc = this.pageVars.filters['ds'].selected;
    if (!loc || loc == 'undefined' || loc == 'all') {
      this.map.setView([38.0, 0.0], 1, { animate: true });
      this.map.setMaxBounds(this.map.getBounds());
    } else {
      if (this.dutyStations) {
        for (let i = 0; i < this.dutyStations.length; i++) {
          const element: any = this.dutyStations[i];
          let tempLoc = loc.replace(/^0+/, '')
          if (element.code && element.code.indexOf(tempLoc) > -1) {
            this.pageVars.locationSelected = element;
            this.map.setView([element.latitude, element.longitude], 8, { animate: true });
          }
        }
      }
    }
  }

  compileTemplate() {
    let metadata = {
      selector: `runtime-component-sample`,
      template: this.template,
      changeDetection: ChangeDetectionStrategy.Default
    };

    let factory = this.createComponentFactorySync(this.compiler, metadata, null, this);

    if (this.componentRef) {
      this.componentRef.destroy();
      this.componentRef = null;
    }
    this.componentRef = this.container.createComponent(factory);
    this.lazyLoadService.loadScript('/assets/js/onehr.js').subscribe(_ => {

    });
  }


  private createComponentFactorySync(compiler: Compiler, metadata: Component, componentClass: any, THIS: any,): ComponentFactory<any> {
    const cmpClass = componentClass || class RuntimeComponent {
      customOptions: OwlOptions = {
        loop: true,
        mouseDrag: true,
        touchDrag: true,
        pullDrag: true,
        dots: true,
        autoHeight: true,
        autoWidth: false,
        animateIn: 'slideIn',
        animateOut: 'slideOut',
        startPosition: 0,
        // center: true,
        margin: 10,
        navSpeed: 100,
        navText: ['<', '>'],
        mergeFit: true,
        responsive: {
          0: {
            items: 1
          },
          600: {
            items: 3
          },
          768: {
            items: 4
          },
          992: {
            items: 5
          },
          1200: {
            items: 7
          }
        },
        nav: false,
      }
      countries = [];
      mapInit = false;
      scalesList: any = [];
      uniqueArray: any = [];

      public ngOnInit() {
        // this.loadScaleInfo();
        this.loadlatestScaleInfo();
        setTimeout(() => {
          this.initMap();
        }, 1000);
      }

      viewScale(_id) {
        THIS.router.navigate(["/viewdutystation/" + _id])
      }

      // loadScaleInfo() {
      //   THIS.scale_service.getScaleData(10).subscribe((res: any) => {
      //     this.scalesList = res.data;
      //     THIS.cdRef.detectChanges();
      //   })
      // }

      loadlatestScaleInfo() {
        THIS.scale_service.getlatestScaleData(100).subscribe((res: any) => {
          this.scalesList = res.data;
          var filterLength = this.removeDuplicates(this.scalesList);
          this.uniqueArray = filterLength.filter((item, index) => index < 30)
          THIS.cdRef.detectChanges();
        })
      }

      removeDuplicates(originalArray) {
        // var newArray = [];
        // var lookupObject = {};
        // for (var i in originalArray) {
        //   lookupObject[originalArray[i][prop]] = originalArray[i];
        // }
        // for (i in lookupObject) {
        //   newArray.push(lookupObject[i]);
        // }
        // return newArray;
        return originalArray.filter((v, i, a) => a.findIndex(ele => (ele.dutyStationId === v.dutyStationId)) === i)

      }

      initMap() {
        this.mapInit = true;
        this.countries.forEach(element => {
          esri.query({
            url: "https://geoservices.un.org/arcgis/rest/services/ClearMap_WebGray/MapServer/110"
          }).where(`ISO3CD='${element.countryId.ISO3CD}'`).run(function (error, geojson) {
            if (error) {
              return;
            }
            L.geoJSON(geojson, {
              style: function (feature) {
                return {
                  radius: 8,
                  fillColor: element.colorId.color,
                  color: element.colorId.color,
                  weight: 1,
                  opacity: 1,
                  fillOpacity: 0.8
                }
              },
              // onEachFeature: function (feature, layer) {
              //   if (feature.properties && feature.properties.ROMNAM) {
              //     //feature.properties.ROMNAM
              //     layer.bindPopup(element.countryId.countryName, { closeButton: false, autoPan: false, offset: L.point(0, -20) });
              //     layer.on('mouseover', function () { layer.openPopup(); });
              //     layer.on('mouseout', function () { layer.closePopup(); });
              //   }
              // },
            })
            // .bindPopup(function (layer: any) {
            //   return layer.feature.properties.name;
            // }).addTo(map);
          });
        });
      }
    };
    const decoratedCmp = Component(metadata)(cmpClass);

    const decoratedNgModule = NgModule({ imports: [CommonModule, CarouselModule], declarations: [decoratedCmp] })(cmpClass);

    const module: ModuleWithComponentFactories<any> = compiler.compileModuleAndAllComponentsSync(decoratedNgModule);
    return module.componentFactories.find(f => f.componentType === decoratedCmp);
  }
}
